import React from 'react'

import SurveyRatingsListComponent from '../../components/SurveyRatings/SurveyRatingsList'

export const SurveyRatingsList = (props) => (
  <SurveyRatingsListComponent {...props} />
)
